// extracted by mini-css-extract-plugin
export default {"root":"SectionRelatedListings_root__WUCiR","title":"SectionRelatedListings_title__pkLDy","listingsGrid":"SectionRelatedListings_listingsGrid__jeOIy"};